"use client";

import { c as _c } from "react/compiler-runtime";
import type { FC, RefObject } from "react";
import { WaveDropsScrollControlsBottomButton } from "./WaveDropsScrollControlsBottomButton";
import { WaveDropsScrollControlsUnreadButton } from "./WaveDropsScrollControlsUnreadButton";
import { useUnreadDividerVisibility } from "./useUnreadDividerVisibility";
interface WaveDropsScrollControlsProps {
  readonly unreadDividerSerialNo: number | null;
  readonly unreadCount?: number | undefined;
  readonly scrollContainerRef: RefObject<HTMLDivElement | null>;
  readonly onScrollToUnread: (serialNo: number) => void;
  readonly onDismissUnread: () => void;
  readonly isAtBottom: boolean;
  readonly scrollToBottom: () => void;
  readonly newMessagesCount: number;
  readonly onRevealNewMessages?: (() => void) | undefined;
}
export const WaveDropsScrollControls: FC<WaveDropsScrollControlsProps> = t0 => {
  const $ = _c(29);
  const {
    unreadDividerSerialNo,
    unreadCount,
    scrollContainerRef,
    onScrollToUnread,
    onDismissUnread,
    isAtBottom,
    scrollToBottom,
    newMessagesCount,
    onRevealNewMessages
  } = t0;
  let t1;
  if ($[0] !== onDismissUnread || $[1] !== scrollContainerRef || $[2] !== unreadDividerSerialNo) {
    t1 = {
      unreadDividerSerialNo,
      scrollContainerRef,
      onDismissUnread
    };
    $[0] = onDismissUnread;
    $[1] = scrollContainerRef;
    $[2] = unreadDividerSerialNo;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    unreadPosition,
    isUnreadVisible,
    dismissUnread
  } = useUnreadDividerVisibility(t1);
  const hasPending = newMessagesCount > 0;
  const isBottomVisible = hasPending || !isAtBottom;
  const isCombined = isUnreadVisible && isBottomVisible;
  if (!isUnreadVisible && !isBottomVisible) {
    return null;
  }
  const isPointingUp = unreadPosition === "above";
  if (isCombined) {
    let t2;
    if ($[4] !== dismissUnread || $[5] !== isPointingUp || $[6] !== onScrollToUnread || $[7] !== unreadCount || $[8] !== unreadDividerSerialNo) {
      t2 = <WaveDropsScrollControlsUnreadButton unreadDividerSerialNo={unreadDividerSerialNo} unreadCount={unreadCount} isPointingUp={isPointingUp} isCombined={true} combinedWidthClassName="tw-w-12 tw-min-w-0 tw-px-0" roundedClassName="tw-rounded-t-full tw-rounded-b-none" onScrollToUnread={onScrollToUnread} onDismissUnread={dismissUnread} />;
      $[4] = dismissUnread;
      $[5] = isPointingUp;
      $[6] = onScrollToUnread;
      $[7] = unreadCount;
      $[8] = unreadDividerSerialNo;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    let t3;
    if ($[10] !== hasPending || $[11] !== newMessagesCount || $[12] !== onRevealNewMessages || $[13] !== scrollToBottom) {
      t3 = <WaveDropsScrollControlsBottomButton hasPending={hasPending} newMessagesCount={newMessagesCount} isCombined={true} combinedWidthClassName="tw-w-12 tw-min-w-0 tw-px-0" roundedClassName="tw-rounded-b-full tw-rounded-t-none" onRevealNewMessages={onRevealNewMessages} scrollToBottom={scrollToBottom} />;
      $[10] = hasPending;
      $[11] = newMessagesCount;
      $[12] = onRevealNewMessages;
      $[13] = scrollToBottom;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    let t4;
    if ($[15] !== t2 || $[16] !== t3) {
      t4 = <div className="tw-absolute tw-bottom-3 tw-right-2 tw-z-[49] tw-flex tw-flex-col tw-items-stretch lg:tw-right-6">{t2}{t3}</div>;
      $[15] = t2;
      $[16] = t3;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    return t4;
  }
  if (isUnreadVisible) {
    let t2;
    if ($[18] !== dismissUnread || $[19] !== isPointingUp || $[20] !== onScrollToUnread || $[21] !== unreadCount || $[22] !== unreadDividerSerialNo) {
      t2 = <div className="tw-absolute tw-bottom-14 tw-right-2 tw-z-[49] tw-flex-shrink-0 lg:tw-bottom-12 lg:tw-right-6"><WaveDropsScrollControlsUnreadButton unreadDividerSerialNo={unreadDividerSerialNo} unreadCount={unreadCount} isPointingUp={isPointingUp} isCombined={false} combinedWidthClassName="tw-w-12 tw-min-w-0 tw-px-0" roundedClassName="tw-rounded-full" onScrollToUnread={onScrollToUnread} onDismissUnread={dismissUnread} /></div>;
      $[18] = dismissUnread;
      $[19] = isPointingUp;
      $[20] = onScrollToUnread;
      $[21] = unreadCount;
      $[22] = unreadDividerSerialNo;
      $[23] = t2;
    } else {
      t2 = $[23];
    }
    return t2;
  }
  let t2;
  if ($[24] !== hasPending || $[25] !== newMessagesCount || $[26] !== onRevealNewMessages || $[27] !== scrollToBottom) {
    t2 = <div className="tw-absolute tw-bottom-3 tw-right-2 tw-z-[49] lg:tw-right-6"><WaveDropsScrollControlsBottomButton hasPending={hasPending} newMessagesCount={newMessagesCount} isCombined={false} combinedWidthClassName="tw-w-12 tw-min-w-0 tw-px-0" roundedClassName="tw-rounded-full" onRevealNewMessages={onRevealNewMessages} scrollToBottom={scrollToBottom} /></div>;
    $[24] = hasPending;
    $[25] = newMessagesCount;
    $[26] = onRevealNewMessages;
    $[27] = scrollToBottom;
    $[28] = t2;
  } else {
    t2 = $[28];
  }
  return t2;
};